import {createTheme} from '@mui/material/styles';


const theme = createTheme({
    palette:{
        primary:{
            "main":'#F857A6',
            "main100":'#fdcbe3',
            "main200":"#fcb2d6",
            "main500":'#f857a6'
        },
        secondary:{
            main:"#FF5858",

        },
        background:{
            default:'#FFF'
        },
        customGradient:{
            primaryGradient: 'linear-gradient(90deg,#F857A6 0%,#FF5858 100%)',
            galssGradient:'linear-gradient(90deg,#F857A6 0%,#FF5858 100%)'
        },
        borders:{
            default:'#e8e8e8'
        }
        
    },

    typography:{
        fontFamily:'"Host Grotesk", sans-serif',
        colorGrey:'#6a6d76'
    }
})

export default theme;